import { useMutation, useQueryClient } from '@tanstack/react-query'
import { employeeRequest } from '@/shared/api'
import { sessionKeys } from './queries'

// PUT /employees/me/timezone — машинная ручка: зону шлёт SPA, увидев расхождение
// с устройством, а не человек из формы. Адресата в пути нет — субъект берётся из
// hub-session. Идемпотентна: тем же значением ничего не меняет.
export function useReportTimezone() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (timezone: string) =>
      employeeRequest<unknown>({
        method: 'PUT',
        path: '/employees/me/timezone',
        body: { timezone },
      }),
    // Сессия перечитывается, чтобы сохранённая зона сошлась с устройством и
    // сверка не повторялась на каждом рендере.
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: sessionKeys.me })
    },
  })
}
